import { Popconfirm } from "antd";
import { IoRefresh } from "react-icons/io5";

import { AdvisorButton } from "./AdvisorButton";
import { Badge } from "./Badge";

const DISCLAIMER =
  "Offer Advisor uses your internal payroll and market data. Verify your data for accurate, optimal results.";

// antd v4's Popconfirm has no `description` prop (that arrived in v5), so the explanation has to
// be composed into the title or it is silently dropped.
const RESET_CONFIRM_TITLE = (
  <div className="max-w-xs">
    <div className="font-medium text-gray-800">Reset this conversation?</div>
    <div className="mt-1 whitespace-normal text-xs font-normal leading-snug text-gray-500">
      This clears everything so far and starts a brand new session — use it if
      the advisor gets stuck. This can&apos;t be undone.
    </div>
  </div>
);

/**
 * Passed as the antd Drawer's `title`. The reset control lives here rather than only at the end
 * of a finished conversation, since it's mainly for recovering one that's stuck mid-run.
 *
 * It hides once the conversation completes, leaving the transcript's own "Start another session"
 * as the next step — so there is exactly one restart affordance on screen at a time.
 */
export function AdvisorHeader({
  isComplete,
  onRestart,
}: {
  isComplete: boolean;
  onRestart: () => void;
}) {
  return (
    <div className="flex items-start justify-between gap-3 pr-6">
      <div className="min-w-0">
        <div className="truncate text-base font-semibold text-gray-800">
          TOM - AI Offer Advisor
        </div>
        <div className="mt-0.5 max-w-md whitespace-normal text-xs font-normal leading-snug text-gray-500">
          {DISCLAIMER}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2 pt-0.5">
        {isComplete ? (
          <Badge variant="success">Complete</Badge>
        ) : (
          <Popconfirm
            title={RESET_CONFIRM_TITLE}
            okText="Reset"
            cancelText="Cancel"
            okType="danger"
            placement="bottomRight"
            onConfirm={onRestart}
          >
            <AdvisorButton size="sm" title="Reset conversation">
              <IoRefresh className="h-3.5 w-3.5" />
              Reset
            </AdvisorButton>
          </Popconfirm>
        )}
      </div>
    </div>
  );
}
